interface CrownIconProps {
  width: string;
  height: string;
}
const CrownIcon = (props: CrownIconProps) => {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 48 42"
      fill="none">
      <g clipPath="url(#clip0_141_7358)">
        <path
          d="M25.3477 8.69531C26.2828 8.12109 26.9062 7.0793 26.9062 5.90625C26.9062 4.09336 25.4379 2.625 23.625 2.625C21.8121 2.625 20.3438 4.09336 20.3438 5.90625C20.3438 7.0875 20.9672 8.12109 21.9023 8.69531L17.202 18.0961C16.4555 19.5891 14.5195 20.0156 13.2152 18.9738L5.90625 13.125C6.31641 12.5754 6.5625 11.8945 6.5625 11.1562C6.5625 9.34336 5.09414 7.875 3.28125 7.875C1.46836 7.875 0 9.34336 0 11.1562C0 12.9691 1.46836 14.4375 3.28125 14.4375H3.33867L7.0875 35.0602C7.53867 37.5539 9.7125 39.375 12.2555 39.375H34.9945C37.5293 39.375 39.7031 37.5621 40.1625 35.0602L43.9113 14.4375H43.9688C45.7816 14.4375 47.25 12.9691 47.25 11.1562C47.25 9.34336 45.7816 7.875 43.9688 7.875C42.1559 7.875 40.6875 9.34336 40.6875 11.1562C40.6875 11.8945 40.9336 12.5754 41.3438 13.125L34.0348 18.9738C32.7305 20.0156 30.7945 19.5891 30.048 18.0961L25.3477 8.69531Z"
          fill="#16203B"
        />
      </g>
      <defs>
        <clipPath id="clip0_141_7358">
          <rect width="47.25" height="42" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default CrownIcon;
